var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibleOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_17798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33204 9.5C4.68183 10.0796 5.0929 10.6165 5.55604 11.1013M19.668 9.5C19.3183 10.0796 18.9072 10.6165 18.4441 11.1013M9.24791 13.4375C10.1154 13.7216 11.0402 13.875 12 13.875C12.9599 13.875 13.8847 13.7216 14.7522 13.4375M9.24791 13.4375L8.31818 16.5M9.24791 13.4375C7.83239 12.9739 6.56955 12.1623 5.55604 11.1013M14.7522 13.4375L15.6818 16.5M14.7522 13.4375C16.1677 12.9739 17.4305 12.1623 18.4441 11.1013M5.55604 11.1013L3 12.5625M18.4441 11.1013L21 12.5625",
    stroke: "#111B48",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_17798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibleOff);
export default __webpack_public_path__ + "static/media/visible-off.5af02a583804e91a09bfde589430334e.svg";
export { ForwardRef as ReactComponent };